import { render, staticRenderFns } from "./RecruitInfo.vue?vue&type=template&id=5570afd3&scoped=true&"
import script from "./RecruitInfo.vue?vue&type=script&lang=js&"
export * from "./RecruitInfo.vue?vue&type=script&lang=js&"
import style0 from "./RecruitInfo.vue?vue&type=style&index=0&id=5570afd3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5570afd3",
  null
  
)

export default component.exports